// membersData.js
import karan from  '../../assets/Team images/Karan.jpg'

import { faHtml5, faCss3Alt, faJs,faReact,faPython,faAws,faNodeJs, faLinkedin, faGithub} from '@fortawesome/free-brands-svg-icons'; 
import { faInstagram,faFacebook,faDiscord,faTwitter,faReddit } from '@fortawesome/free-brands-svg-icons'; 
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

export const skillsData = [
    { name: "HTML", icon: faHtml5 },
    { name: "CSS", icon: faCss3Alt },
    { name: "JavaScript", icon: faJs },
    { name: "React", icon: faReact },
    { name: "Python", icon: faPython },
    { name: "Aws", icon: faAws },
    { name: "NodeJs", icon: faNodeJs },
    
    
];
export const socialMediaData = {
    "facebook": faFacebook,
    "twitter": faTwitter,
    "instagram": faInstagram,
    "discord":faDiscord,
    "reddit": faReddit,
    "linkedin":faLinkedin,
    "github":faGithub,
    "email":faEnvelope

};



export const productData = [
    {
        name: "Face X",
        description: `I thrive on creative challenges and strategic thinking. Tech, health, and fitness are integral to my lifestyle.`, 
        imageUrl: karan,
        
        
    },
    {
        name: "Face X",
        description: `I thrive on creative challenges and strategic thinking. Tech, health, and fitness are integral to my lifestyle.`, 
        imageUrl: karan,
        
        
    },
     {
        name: "Face X",
        description: `I thrive on creative challenges and strategic thinking. Tech, health, and fitness are integral to my lifestyle.`, 
        imageUrl: karan,
        
        
    },
    
    

];



